import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ small, primary, normal, normalWhite, mini, normalSuccess, gray, className }) => {
  let loaderClasses = 'loader';

  if(className) {
    loaderClasses += ` ${className}`;
  }

  if(small) {
    loaderClasses += ' loader--small';
  }

  if(primary) {
    loaderClasses += ' loader--primary';
  }

  if(normal) {
    loaderClasses += ' loader--normal';
  }

  if(normalWhite) {
    loaderClasses += ' loader--normal-white';
  }

  if(mini) {
    loaderClasses += ' loader--mini';
  }

  if(normalSuccess) {
    loaderClasses += ' loader--normal-success';
  }

  if(gray) {
    loaderClasses += ' loader--gray';
  }

  return(
    <div className={loaderClasses}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

Loader.propTypes = {
  small: PropTypes.bool,
  primary: PropTypes.bool,
  normal: PropTypes.bool
}

export default Loader;